import { css } from '@emotion/css';

export const fullscreenButton = css`
  label: fullscreen;
  margin-left: -2px;
`;
